<template>
  <div class="safedig-info-layout">
    <SafeDigHeader />
    <div class="safedig-content-wrapper">
      <div class="siteSidebarAndContent siteSidebarAndContentWhiteBg" :class="{ 'safedig-no-sidebar': hideSidebar }">
        <aside v-show="!hideSidebar" class="safedig-sidebar">
          <div class="safedig-sidebar-section">
            <button type="button" class="safedig-sidebar-title" :class="{ expanded: infoMenuOpen }"
              @click="infoMenuOpen = !infoMenuOpen">
              {{ $t('sidebar.info') }}
            </button>
            <nav v-show="infoMenuOpen" class="safedig-sidebar-nav">
              <router-link to="/info/contact_us" class="safedig-sidebar-link" active-class="active">
                {{ $t('sidebar.contactUs') }}
              </router-link>
              <router-link to="/info/whats_new" class="safedig-sidebar-link" active-class="active">
                {{ $t('sidebar.whatsNew') }}
              </router-link>
              <router-link to="/info/community" class="safedig-sidebar-link" active-class="active">
                {{ $t('sidebar.community') }}
              </router-link>
              <router-link to="/info/events" class="safedig-sidebar-link" active-class="active">
                {{ $t('sidebar.eventsCalendar') }}
              </router-link>
            </nav>
          </div>
        </aside>
        <main class="safedig-main-content" :class="{ 'safedig-main-fullwidth': hideSidebar }">
          <router-view />
        </main>
      </div>
    </div>
    <div class="siteFooter footerOffWhite safedigFooter safedigInfoFooter">
      <div class="safedigCustomFooter">
        <div>
          <img src="../../../assets/safe-dig/safedig_logo_grayscale-01.png" class="safedigindiana811Logo"
            alt="Safe Dig Indiana">
        </div>
        <p class="copyright">
          {{ $t('footer.copyright', { year }) }}<br>
          {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SafeDigHeader from '@/components/safe-dig/Header.vue';

export default {
  name: 'SafeDigInfoLayout',
  components: {
    SafeDigHeader
  },
  data() {
    return {
      infoMenuOpen: true,
      year: new Date().getFullYear()
    };
  },
  computed: {
    isGrantsPage() {
      return this.$route.path === '/info/grants';
    },
    isEventsPage() {
      return this.$route.path === '/info/events';
    },
    hideSidebar() {
      return this.isGrantsPage || this.isEventsPage;
    }
  }
};
</script>

<style scoped>
.safedig-info-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.safedig-content-wrapper {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 0;
  padding: 0 1rem;
}

.siteSidebarAndContent {
  display: flex;
  flex: 1;
  min-height: 0;
}

.siteSidebarAndContentWhiteBg {
  background: #fff;
}

.safedig-sidebar {
  flex-shrink: 0;
  width: 260px;
  padding: 24px 0;
  background: #fff;
  position: sticky;
  top:100px;
  align-self: flex-start;
}

.safedig-sidebar-section {
  background: #7a8fa3;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #3e7799;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);
}

.safedig-sidebar-title {
  width: 100%;
  padding: 6px 15px;
  background: #7a8fa3;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.2s;
}

.safedig-sidebar-title:hover {
  background: #6b7f92;
}

.safedig-sidebar-title::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid currentColor;
  transition: transform 0.2s;
}

.safedig-sidebar-title.expanded::after {
  transform: rotate(180deg);
}

.safedig-sidebar-nav {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.safedig-sidebar-link {
  padding: 10px 15px;
  color: #1e3a5f;
  text-decoration: none;
  font-size: 16px;
  transition: background 0.15s, color 0.15s;
}

.safedig-sidebar-link:hover {
  background: #f3f4f6;
}

.safedig-sidebar-link.active {
  background: #9c3c21;
  color: #fff;
}

.safedig-main-content {
  flex: 1;
  padding: 2rem 3rem 3rem;
  overflow-y: auto;
}

.safedig-main-fullwidth {
  padding: 0;
}

.siteFooter {
  width: 100%;
}

.safedigFooter {
  background: #e8e8e8;
}

.safedigInfoFooter .safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.safedigindiana811Logo {
  height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.85rem;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .siteSidebarAndContent {
    flex-direction: column;
  }

  .safedig-sidebar {
    width: 100%;
    padding: 1rem;
    
  }

  .safedig-main-content {
    padding: 1.5rem;
  }
}
@media (max-width: 576px) {
  
  .safedig-sidebar {
    width: 100%;
    padding: 1rem;
    position: static;
  }

  .safedig-main-content {
    padding: 0rem;
  }
}
</style>
